/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseDocuments200,
  GetApiV1DocumentCourseDocuments400,
  GetApiV1DocumentCourseDocuments401,
  GetApiV1DocumentCourseDocuments500,
  GetApiV1DocumentCourseDocumentsQueryParams,
  GetApiV1DocumentCourseDocumentsQueryResponse,
} from "../../types/documentCourseDocumentsController/GetApiV1DocumentCourseDocuments.ts";
import { courseDocumentsListItemViewModelPaginatedResponseSchema } from "../courseDocumentsListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1DocumentCourseDocumentsQueryParamsSchema = z.object({
  CourseId: z.optional(
    z.coerce
      .number()
      .int()
      .describe("ID do curso cujas declarações serão listadas. Obrigatório."),
  ),
  Search: z.optional(
    z
      .string()
      .describe(
        "Texto livre aplicado ao nome do documento. Máximo de 200 caracteres. Opcional.",
      ),
  ),
  PageNumber: z.coerce
    .number()
    .int()
    .default(1)
    .describe("Página da listagem. Mínimo 1."),
  PageSize: z.coerce
    .number()
    .int()
    .default(30)
    .describe("Quantidade de itens por página. Entre 1 e 100."),
}) as unknown as ToZod<GetApiV1DocumentCourseDocumentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseDocuments200Schema = z.lazy(
  () => courseDocumentsListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1DocumentCourseDocuments200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1DocumentCourseDocuments400Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocuments400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocuments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocuments500>;

export const getApiV1DocumentCourseDocumentsQueryResponseSchema = z.lazy(
  () => getApiV1DocumentCourseDocuments200Schema,
) as unknown as ToZod<GetApiV1DocumentCourseDocumentsQueryResponse>;
